module.exports = "data:image/gif;base64,R0lGODlhDwAPAKIAAFtbW1VVVWhoaGJiYv///wAAAAAAAAAAACH5BAAAAAAALAAAAAAPAA8AAAMvOLHcPGCISauAwOoJ4vhg+HVkSZSoeaYo4bLqC5PuOnfyjbNOv3S+HjDYAAR0wAQAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/shared/left-btn.gif
 ** module id = 524
 ** module chunks = 0
 **/